export const LINE_HEIGHT_OPTIONS = ['0.8', '0.9', '1', '1.2', '1.5', '2'] as const;
export type LineHeightOptions = typeof LINE_HEIGHT_OPTIONS[number];
